/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const PropertyWrapper = ({ property1, className }) => {
  return (
    <div className={`property-wrapper ${className}`}>
      <div className={`rectangle ${property1}`} />
    </div>
  );
};

PropertyWrapper.propTypes = {
  property1: PropTypes.oneOf(["fifty", "one"]),
};
